// extracted by mini-css-extract-plugin
module.exports = {"container":"e_VC","link":"e_WC","lastLink":"e_XC","arrow":"e_YC"};